var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMessagePlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  viewBox: "0 0 80 80"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  stroke: "#69728B"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M7 7a4 4 0 0 0-4 4v61.492L17.688 57H73a4 4 0 0 0 4-4V11a4 4 0 0 0-4-4z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 35,
  height: 1,
  x: 17.5,
  y: 43.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 1,
  x: 17.5,
  y: 31.5,
  rx: 0.5
}), /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 1,
  x: 17.5,
  y: 19.581,
  rx: 0.5
}))));
export default SvgMessagePlaceholder;